module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mx-preload"
  }, [_c('div', {
    staticClass: "logo-animated",
    attrs: {
      "alt": "Loading..."
    }
  }, [_c('svg', {
    attrs: {
      "width": "208",
      "height": "120",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "a",
      "d": "M0 .075h175.989v87.782H0z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(16 16.068)"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M175.989.075C129.863 19.778 46.125 19.778 0 .075l14.666 73.15c37.406 19.471 106.424 19.548 146.657 0L175.99.075z",
      "fill": "red",
      "mask": "url(#b)"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M57.837 49.058l-2.77 16.027-.186 1.077h-.361l-.185-1.068-2.771-16.036-5.564.005V78.32h4.302l.018-8.646-.37-9.778h.347l3.269 18.424h2.269l3.268-18.424h.347l-.37 9.778v8.646h4.32V49.063zM74.924 49.058l-.116 24.447c0 1.284-1.155 1.582-1.734 1.582-.652 0-1.734-.298-1.734-1.582l-.116-24.447h-4.7l.388 23.33c0 4.115 1.468 6.3 6.162 6.3 4.693 0 6.162-2.185 6.162-6.3l.388-23.33h-4.7zM87.45 74.667V49.058h-4.7v29.258h9.89v-3.649zM132.09 74.667V49.058h-4.7v29.258h9.643v-3.649zM147.464 52.707v-3.649h-9.81V78.318h9.743v-3.649h-5.043V63.755h3.76v-3.649h-3.76v-7.4zM103.456 49.058H90.677v3.52h4.04v25.74h4.7v-25.74h4.039zM105.254 78.316h4.7V49.058h-4.7zM120.708 60.612c0 1.139-.248 2.184-2.12 2.184h-.82V52.704h1.157c2.008 0 1.783 1.309 1.783 2.448v5.46zm-1.336-11.552l-6.305-.002v29.258h4.7V66.47h1.76c3.953 0 5.881-2.017 5.881-5.158v-6.796c0-3.142-1.426-5.457-6.036-5.457zM162.362 49.062h-4.638l-1.978 10.888h-.36l-1.978-10.888h-4.638l2.927 12.597-3.223 16.658h4.81l1.678-10.054.426-4.794h.352l.43 4.794 1.647 10.054h4.84l-3.223-16.658z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71098f9d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entities/preloader/index.vue
// module id = 425
// module chunks = 1